module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "footer-colums"
    }
  }, [_c('div', {
    staticClass: "footer-colum"
  }, [_c('h4', [_vm._v("Company")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_vm._v("\n                FAQ\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("\n                Contact Us\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/disclaimer'
      }
    }
  }, [_vm._v("\n                Disclaimer\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/privacy'
      }
    }
  }, [_vm._v("\n                Privacy Policy\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/terms'
      }
    }
  }, [_vm._v("\n                Terms of Use\n              ")])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-colum"
  }, [_c('h4', [_vm._v("Contact Methods")]), _vm._v(" "), _c('ul', [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("\n                Email\n              ")])], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "footer-colum no-margin"
  }, [_c('h4', [_vm._v("From The Blog")]), _vm._v(" "), _c('ul', _vm._l((_vm.posts), function(post) {
    return _c('li', {
      key: post.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/blog'
        }
      }
    }, [_vm._v("\n                " + _vm._s(post) + "\n              ")])], 1)
  }))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bottom-footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "alignleft"
  }, [_vm._v("\n          © Copyright 2009-" + _vm._s(_vm.year) + " StumptheSpread.com. All rights\n          reserved.\n        ")]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('login')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-colum"
  }, [_c('h4', [_vm._v("Get Social with Us")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://twitter.com/#!/StumpTheSpread",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCUPBXcfLwRpmtGlDqmYmiXQ",
      "target": "_blank"
    }
  }, [_vm._v("Youtube")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://stumpthespread.com/register"
    }
  }, [_vm._v("Mailing List")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "mailto:support@stumpthespread.com"
    }
  }, [_vm._v("support@stumpthespread.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "alignright",
    attrs: {
      "id": "social-list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://stumpthespread.com/maillst/?p=subscribe&id=1",
      "target": "_blank",
      "rel": "tipsy",
      "title": "Monthly Newsletter"
    }
  }, [_c('div', {
    staticClass: "sprite email"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://twitter.com/#!/StumpTheSpread",
      "target": "_blank",
      "rel": "tipsy",
      "title": "Twitter"
    }
  }, [_c('div', {
    staticClass: "sprite twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCUPBXcfLwRpmtGlDqmYmiXQ",
      "target": "_blank",
      "rel": "tipsy",
      "title": "Youtube"
    }
  }, [_c('div', {
    staticClass: "sprite youtube"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e470f43a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StsFooter.vue
// module id = 529
// module chunks = 1